import React, { useEffect, useState } from "react";
import { GetNewsFlash } from "../../../api's/homeAPI";
import { Card, Flex } from "antd";
import { CustomParagraph } from "../../../components";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../../components/SpinContext";
import { useToken } from "../../../common/helper";

import { ChevronRightIcon, CrossIcon } from "../../../assets/icons/icons.js";

const NewsFlash = () => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();

  const [newsFlashData, setNewsFlashData] = useState([]);
  const [alertIndex, setAlertIndex] = useState(0);

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const fetchNewsFlashData = () => {
    GetNewsFlash(token)
      .then((res) => {
        const data = res?.data?.data?.data;
        if (res?.data?.data?.is_success) {
          setNewsFlashData(data);
        }
      })
      .catch((error) => {
        console.error("News Flash Error:", error);
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    fetchNewsFlashData();
  }, []);

  const handleDismiss = () => {
    const updated = [...newsFlashData];
    updated.splice(alertIndex, 1);

    setNewsFlashData(updated);

    if (alertIndex >= updated.length) {
      setAlertIndex(Math.max(updated.length - 1, 0));
    }
  };

  return (
    <>
      {newsFlashData?.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <Card
            style={{
              width: "100%",
              borderRadius: "12px",
              border: "2px solid #EEE",
              padding: "0",
            }}
            className="single-card"
            bodyStyle={{ padding: "24px" }}
          >
            <Flex style={{ justifyContent: "space-between" }}>
              <CustomParagraph
                text={newsFlashData[alertIndex]?.title}
                fontSize={18}
                lineHeight="24px"
                fontWeight={700}
                marginBottom={8}
              />
              <span
                style={{ marginTop: "-8px", marginRight: "-8px", cursor: "pointer" }}
                onClick={handleDismiss}
              >
                <CrossIcon />
              </span>
            </Flex>

            <Flex
              justify="space-between"
              align="end"
              className="custom-card-drawer-header"
            >
              <CustomParagraph
                text={newsFlashData[alertIndex]?.message}
                fontSize={14}
                lineHeight="20px"
                fontWeight={400}
                marginBottom={0}
              />

              {newsFlashData.length > 1 && (
                <Flex
                  gap={8}
                  align="center"
                  style={{
                    marginRight: "-15px",
                    marginBottom: "-8px",
                    cursor: "pointer",
                  }}
                  className="custom-card-drawer-header-actions"
                >
                  <button
                    title="Previous News"
                    style={{
                      transform: "rotate(180deg)",
                      alignItems: "center",
                      display: "flex",
                      border: "none",
                      cursor: alertIndex === 0 ? "auto" : "pointer",
                      background: "none",
                    }}
                    onClick={() => {
                      if (alertIndex > 0) setAlertIndex(alertIndex - 1);
                    }}
                  >
                    <ChevronRightIcon
                      fill={alertIndex === 0 ? "#AFAFAF" : "#000"}
                      width={24}
                      height={24}
                      className="breadcrumb-icon"
                    />
                  </button>

                  <button
                    title="Next News"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      border: "none",
                      cursor:
                        alertIndex === newsFlashData.length - 1
                          ? "auto"
                          : "pointer",
                      background: "none",
                    }}
                    onClick={() => {
                      if (alertIndex < newsFlashData.length - 1)
                        setAlertIndex(alertIndex + 1);
                    }}
                  >
                    <ChevronRightIcon
                      fill={
                        alertIndex === newsFlashData.length - 1
                          ? "#AFAFAF"
                          : "#000"
                      }
                      width={24}
                      height={24}
                      className="breadcrumb-icon"
                    />
                  </button>
                </Flex>
              )}
            </Flex>
          </Card>
        </div>
      )}
    </>
  );
};


export default NewsFlash;
